import React, { Component } from "react";
import styles from "../PricingWrapper.module.scss";
import { withTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid";

class ListOfItems extends Component {
  formatEffectiveDate = (effDateIn) => {
    return effDateIn.length >= 10 ? effDateIn.substring(0, 10) : effDateIn;
  };

  render() {
    return (
      <div>
        {this.props.selectedTab === 0 ? (
          <div className={styles.horizonRow}>
            <div className={styles.listOfItems}>
              {(this.props.rowEditedCheckbox.length !== 0 ||
                this.props.newVehiclesReleasedList.length !== 0) &&
              !this.props.rowEditSaved ? (
                <Grid>
                  <span className={styles.listOfItemsNumber}>
                    {this.props.rowEditedCheckbox.length <=
                    this.props.newVehiclesReleasedList.length ? (
                      <span>{this.props.newVehiclesReleasedList.length}</span>
                    ) : (
                      <span>{this.props.rowEditedCheckbox.length}</span>
                    )}
                  </span>
                  <span className={styles.listOfItemsText}>
                    {this.props.t("CurrentPricing.entitiesSelected")}
                  </span>
                  {this.props.futureEffectiveDate ? (
                    <span className={styles.listOfItemsNumber}>
                      {this.props.t("CurrentPricing.futurePricingEffective")}{" "}
                      {this.formatEffectiveDate(this.props.futureEffectiveDate)}
                    </span>
                  ) : (
                    <span className={styles.listOfItemsNumber}></span>
                  )}
                </Grid>
              ) : (
                <Grid>
                  <span className={styles.listOfItemsNumber}>
                    {this.props.feesData.length}
                  </span>
                  <span className={styles.listOfItemsText}>
                    {this.props.t("CurrentPricing.entitiesShown")}
                  </span>
                  {this.props.futureEffectiveDate ? (
                    <span className={styles.listOfItemsNumber}>
                      {this.props.t("CurrentPricing.futurePricingEffective")}{" "}
                      {this.formatEffectiveDate(this.props.futureEffectiveDate)}
                    </span>
                  ) : (
                    <span className={styles.listOfItemsNumber}></span>
                  )}
                </Grid>
              )}
            </div>
            <hr />
          </div>
        ) : this.props.selectedTab === 1 ? (
          <div className={styles.horizonRow}>
            <div className={styles.listOfItems}>
              {(this.props.rowEditedCheckbox.length !== 0 ||
                this.props.newVehiclesReleasedList.length !== 0) &&
              !this.props.rowEditSaved ? (
                <Grid>
                  <span className={styles.listOfItemsNumber}>
                    {this.props.rowEditedCheckbox.length <=
                    this.props.newVehiclesReleasedList.length ? (
                      <span>{this.props.newVehiclesReleasedList.length}</span>
                    ) : (
                      <span>{this.props.rowEditedCheckbox.length}</span>
                    )}
                  </span>
                  <span className={styles.listOfItemsText}>
                    {this.props.t("CurrentPricing.entitiesSelected")}
                  </span>
                  {this.props.futureEffectiveDate ? (
                    <span className={styles.listOfItemsNumber}>
                      {this.props.t("CurrentPricing.futurePricingEffective")}{" "}
                      {this.formatEffectiveDate(this.props.futureEffectiveDate)}
                    </span>
                  ) : (
                    <span className={styles.listOfItemsNumber}></span>
                  )}
                </Grid>
              ) : (
                <Grid>
                  <span className={styles.listOfItemsNumber}>
                    {this.props.feesData.length}
                  </span>
                  <span className={styles.listOfItemsText}>
                    {this.props.t("CurrentPricing.entitiesShown")}
                  </span>
                  {this.props.futureEffectiveDate ? (
                    <span className={styles.listOfItemsNumber}>
                      {this.props.t("CurrentPricing.futurePricingEffective")}{" "}
                      {this.formatEffectiveDate(this.props.futureEffectiveDate)}
                    </span>
                  ) : (
                    <span className={styles.listOfItemsNumber}></span>
                  )}
                </Grid>
              )}
            </div>
            <hr />
          </div>
        ) : (
          <div className={styles.horizonRow}>
            <div className={styles.listOfItems}>
              {(this.props.rowOptionsEditedCheckbox.length !== 0 ||
                this.props.newOptionsReleasedList.length !== 0) &&
              !this.props.rowEditSaved ? (
                <Grid>
                  <span className={styles.listOfItemsNumber}>
                    {this.props.rowOptionsEditedCheckbox.length <=
                    this.props.newOptionsReleasedList.length ? (
                      <span>{this.props.newOptionsReleasedList.length}</span>
                    ) : (
                      <span>{this.props.rowOptionsEditedCheckbox.length}</span>
                    )}
                  </span>
                  <span className={styles.listOfItemsText}>
                    {this.props.t("Options.optionsSelected")}
                  </span>
                  {this.props.futureEffectiveDate ? (
                    <span className={styles.listOfItemsNumber}>
                      {this.props.t("CurrentPricing.futurePricingEffective")}{" "}
                      {this.formatEffectiveDate(this.props.futureEffectiveDate)}
                    </span>
                  ) : (
                    <span className={styles.listOfItemsNumber}></span>
                  )}
                </Grid>
              ) : (
                <Grid>
                  <span className={styles.listOfItemsNumber}>
                    {this.props.optionsData.length}
                  </span>
                  <span className={styles.listOfItemsText}>
                    {this.props.t("Options.optionsShown")}
                  </span>
                  {this.props.futureEffectiveDate ? (
                    <span className={styles.listOfItemsNumber}>
                      {this.props.t("CurrentPricing.futurePricingEffective")}{" "}
                      {this.formatEffectiveDate(this.props.futureEffectiveDate)}
                    </span>
                  ) : (
                    <span className={styles.listOfItemsNumber}></span>
                  )}
                </Grid>
              )}
            </div>
            <hr />
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation("emp")(ListOfItems);
